<template>
<div>
  <h4>Ogłoszenia</h4>

  <router-link :to="getRouteToAdd" class="btn btn-primary">Dodaj ogłoszenie</router-link>

  <br>
  <br>

  <table class="table table-striped table-bordered table-hover">
    <thead>
    <tr>
      <th>Nagłówek</th>
      <th>Data</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(notice, index) in notices">
      <td>{{ notice.header }}</td>
      <td>{{ notice.date|date }}</td>
      <td>
        <router-link :to="getRouteToEdit(notice)" class="btn btn-default btn-sm">Edytuj</router-link>
        <question-button
          @click="remove(notice)"
          class="btn btn-danger btn-sm"
          question="Czy na pewno usunąć to ogłoszenie?"
        >
          Usuń
        </question-button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import Api from './../api'
import QuestionButton from './QuestionButton.vue'
import Flash from './../Flash'

export default {
  data () {
    return {
      notices: []
    }
  },
  components: {
    QuestionButton
  },
  methods: {
    remove (notice) {
      Api.notice.remove(notice.id).then(this.onRemoveSuccess(notice), this.onRemoveError)
    },
    onRemoveSuccess (notice) {
      return () => {
        this.notices.splice(this.notices.indexOf(notice), 1)
        Flash.success('Ogłoszenie zostało poprawnie usuniętę')
      }
    },
    onRemoveError () {
      Flash.error('Wystąpił nieoczekiwany błąd podczas usuwania ogłoszenia, skontaktuj się z administratorem')
    },
    getRouteToEdit (notice) {
      return {
        name: 'NoticeEdit',
        params: {
          id: notice.id
        }
      }
    },
    fetchData () {
      Api.notice.getList().then(this.fetchSuccess)
    },
    fetchSuccess ({body}) {
      this.notices = body
    }
  },
  computed: {
    getRouteToAdd () {
      return {
        name: 'NoticeAdd'
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Notices.vue?48073882